import styled from 'styled-components';
import {
  OFFLINE_BOOKING_ACCENT_COLOR,
  OFFLINE_BOOKING_BACKGROUND_COLOR,
} from 'pages/inbox/Inbox.constants';

export const InboxVrboOfflineBookingAlertContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 16px 20px;
  border-radius: 6px;
  background-color: ${OFFLINE_BOOKING_BACKGROUND_COLOR};

  > svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-top: 2px;

    path {
      fill: ${OFFLINE_BOOKING_ACCENT_COLOR};
    }
  }

  h4 {
    margin-top: 0;
    margin-bottom: 4px;
    font-weight: bold;
    font-size: 16px;
  }

  div {
    font-size: 14px;
  }

  a {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: bold;

    svg {
      width: 12px;
      height: 12px;
      margin-top: 0;

      path {
        fill: inherit;
      }
    }
  }
`;
